<template>
  <b-card-body>
    <b-row v-if="isRandomLogicTest">
      <b-col lg="2">
        <b-form-group id="hasNumericalImagesGroup">
          <span class="fieldHeader">{{$t('privatePage.numericalImageType_header')}}:</span>

          <b-form-select id="hasNumericalImagesForm"
                        v-model="question.hasNumericalImages"
                        :options="hasNumericalImagesOptions"
                        value-field="value"
                        text-field="text"
                        novalidate
                        required>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-form-group id="difficultyLevelGroup">
          <span class="fieldHeader">{{$t('privatePage.logicTestLevel_desc')}}:</span>

          <b-form-input id="difficultyLevelInput"
                        type="number"
                        v-model="question.difficultyLevel"
                        required
                        :min="1">
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="(alternative, alternativeIndex) in question.alternatives" :key="alternativeIndex" lg="1" style="padding: 0px; margin-left: 15px; margin-bottom: 15px; min-width: 150px;">

        <b-card v-show="!question.hasNumericalImages">
          <b-form-group>
            <input :id="`alternative-${alternative.questionAlternativeId}`" class="me-2" type="checkbox" :checked="alternative.points > 0" :value="1" @change="e => onSelectAlternative(e, alternative)" />
            <label :for="`alternative-${alternative.questionAlternativeId}`">
              {{ $t('privatePage.scaleQuestionsAnswer') }}
            </label>
          </b-form-group>

          <b-row>
            <b-col>
              <b-img :src="alternative.imageUrl" fluid alt="" center />
            </b-col>
          </b-row>
          <b-row align-h="center">
              <b-button class="fa fa-plus modalButton" variant="primary"
                        @click.stop="$emit('showImageBank', alternative)" />
              <b-button class="fa fa-trash modalButton" variant="danger"
                        @click.stop="deleteObjectFromCollection(question.alternatives, alternativeIndex)" />
          </b-row>
        </b-card>

        <b-card v-show="question.hasNumericalImages" style="padding: 10px;">
          <b-form-group>
            <input :id="`alternative-${alternative.questionAlternativeId}`" class="me-2" type="checkbox" :checked="alternative.points > 0" :value="1" @change="e => onSelectAlternative(e, alternative)" />
            <label :for="`alternative-${alternative.questionAlternativeId}`">
              {{ $t('privatePage.scaleQuestionsAnswer') }}
            </label>
          </b-form-group>

          <b-row style="padding: 0px;">
            <b-input-group style="margin-bottom: 5px;">
              <b-form-input type="number" v-model="alternative.text" />
                <b-input-group-append>
                  <b-button variant="danger"
                        class="fa fa-trash"
                        @click.stop="deleteObjectFromCollection(question.alternatives, alternativeIndex)" >
                  </b-button>
                </b-input-group-append>
            </b-input-group>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-button class="addButton me-2" @click.stop="addAlternative(question.alternatives)">
          {{ $t('privatePage.scaleQuestionsAlternativeAdd') }}
        </b-button>

        <b-button ref="deleteQuestionButton"
          variant="danger"
          v-if="isPartOfCollection"
          @click.stop="$emit('onDeleteQuestion', questionIndex)">
          {{ $t('privatePage.scaleQuestionsDelete') }}
        </b-button>
      </b-col>
    </b-row>
  </b-card-body>
</template>

<script>
import editorFuncs from '../questioneditorfuncs'

export default {
  name: 'gfair-module',
  props: {
    question: {},
    questionIndex: 0,
    isPartOfCollection: false,
    isRandomLogicTest: false
  },
  methods: {
    deleteObjectFromCollection(collection, index) {
      editorFuncs.deleteObjectFromCollection(collection, index)
    },
    addAlternative() {
      editorFuncs.addAlternative(
        this.question.alternatives
      )
    },
    onSelectAlternative(event, selected) {
      const value = event.target.value
      const checked = event.target.checked
      if (checked) {
        selected.points = value
      } else {
        selected.points = 0
      }
    }
  },
  computed: {
    hasNumericalImagesOptions() {
      return [
        { value: false, text: this.$t('image') },
        { value: true, text: this.$t('numeric') }
      ]
    }
  },
  created() {
    if (this.question.alternatives.length === 0) {
      this.addAlternative()
    }
  }
}
</script>

<style scoped>
.modalButton {
  margin: 15px 0px 15px 0px;
}
</style>
